// extracted by mini-css-extract-plugin
module.exports = {"root":"button_root__2VZNN","submit":"button_submit__vUbDi"};